/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
import {HTML_ID} from '@sail/engine';
import {initAccessoryLayer} from './initAccessoryLayer';
import {initIframeErrorReporter} from '../utils/IframeErrorReporter';
import {isConnectElementTag} from '../../connect/utils/connectElementTags';
import {embeddedComponentParamName} from '../buildUILayerFrame';

// This frame expects to receive the embedded component to render at load time via a hash param.
const searchParams = new URLSearchParams(location.hash.replace('#', ''));
const embeddedComponent = searchParams.get(embeddedComponentParamName);
if (!embeddedComponent) {
  throw new Error('Missing embedded component query param');
}
if (!isConnectElementTag(embeddedComponent)) {
  throw new Error(`Invalid embedded component ${embeddedComponent}`);
}

const errorReporter = initIframeErrorReporter({
  iframeLayer: 'accessory-layer',
  connectElement: embeddedComponent,
});

// Set styles on the Accessory layer since we do not want to add an `unsafe-inline` directive for the `style-src` CSP policy
document.body.style.margin = '0px';
document.body.style.padding = '0px';
document.body.style.overflow = 'hidden';
const rootElement = document.getElementById('root');
if (!rootElement) {
  const error = new Error('Missing root element in Accessory layer!');
  errorReporter.captureIframeException(error);
  throw error;
}
rootElement.style.zIndex = '299';
rootElement.style.position = 'absolute';
rootElement.style.inset = '0px';
rootElement.style.overflow = 'hidden';
rootElement.style.display = 'flex';

document.documentElement.setAttribute('id', HTML_ID);

initAccessoryLayer();
